import React, { useState } from 'react';
// @ts-ignore
import styles from './InsuranceCompanyInsuranceExport.module.scss';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import InsuranceCompanyInsuranceExportGenModal from '../InsuranceCompanyInsuranceExportGen/InsuranceCompanyInsuranceExportGenModal';

interface Props {
	insuranceCompanyCode: string;
	name: string;
	rootWorkplaceId: string;
}

const InsuranceCompanyInsuranceExport: React.FC<Props> = ({
	insuranceCompanyCode,
	rootWorkplaceId,
	name,
}) => {
	const [isGenOpen, setIsGenOpen] = useState(false);

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<div className={styles.title}>{name}</div>
				</div>
				<div className={styles.controls}>
					<Button
						onClick={() => setIsGenOpen(true)}
						title='component.insuranceCompanyInsuranceExport.generate'
						theme={Theme.GREEN}
					/>
				</div>
			</div>
			{isGenOpen && (
				<InsuranceCompanyInsuranceExportGenModal
					insuranceCompanyCode={insuranceCompanyCode}
					rootWorkplaceId={rootWorkplaceId}
					onClose={() => setIsGenOpen(false)}
					isOpen
				/>
			)}
		</>
	);
};

export default InsuranceCompanyInsuranceExport;
